// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── EssensreihenfolgeVerwaltung ─── */

.reihenfolge-admin-hinweis {
  font-family: 'Circular', sans-serif;
  font-size: 0.9em;
  color: var(--primary-dark);
  margin: 0 0 12px;
}

.reihenfolge-admin-liste {
  list-style: none;
  margin: 0 0 12px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.reihenfolge-admin-liste li {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(180, 200, 130, 0.5);
  border-radius: 8px;
  padding: 6px 10px;
  font-family: 'Circular', sans-serif;
  color: var(--dunkelgruen);
}

.reihenfolge-admin-position {
  font-weight: bold;
  min-width: 1.8em;
  text-align: right;
}

.reihenfolge-admin-zelt {
  flex: 1 1;
}

.reihenfolge-admin-buttons {
  display: flex;
  gap: 4px;
}

.reihenfolge-admin-buttons button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: none;
  border-radius: 6px;
  background-color: transparent;
  color: #0074b3;
  cursor: pointer;
  width: auto;
  min-height: auto;
}

.reihenfolge-admin-buttons button:hover:not(:disabled) {
  background-color: rgba(0, 116, 179, 0.15);
}

.reihenfolge-admin-buttons button:disabled {
  opacity: 0.3;
  cursor: default;
}

.reihenfolge-admin-buttons button .material-symbols-outlined {
  font-size: 1.2rem;
}

.reihenfolge-admin-buttons .reihenfolge-admin-entfernen {
  color: var(--blutorange);
}

.reihenfolge-admin-buttons .reihenfolge-admin-entfernen:hover:not(:disabled) {
  background-color: rgba(200, 60, 30, 0.15);
}

/* ─── Zelt hinzufügen ─── */

.reihenfolge-admin-hinzufuegen {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.reihenfolge-admin-hinzufuegen input[type="text"] {
  flex: 1 1;
  margin-bottom: 0;
}

.reihenfolge-admin-hinzufuegen .btn-save {
  flex: 0 0 auto;
  padding: 0 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  width: auto;
  min-height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/listen/essensreihenfolge/EssensreihenfolgeVerwaltung.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* ─── EssensreihenfolgeVerwaltung ─── */\n\n.reihenfolge-admin-hinweis {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9em;\n  color: var(--primary-dark);\n  margin: 0 0 12px;\n}\n\n.reihenfolge-admin-liste {\n  list-style: none;\n  margin: 0 0 12px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.reihenfolge-admin-liste li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: rgba(180, 200, 130, 0.5);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-family: 'Circular', sans-serif;\n  color: var(--dunkelgruen);\n}\n\n.reihenfolge-admin-position {\n  font-weight: bold;\n  min-width: 1.8em;\n  text-align: right;\n}\n\n.reihenfolge-admin-zelt {\n  flex: 1;\n}\n\n.reihenfolge-admin-buttons {\n  display: flex;\n  gap: 4px;\n}\n\n.reihenfolge-admin-buttons button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  margin: 0;\n  border: none;\n  border-radius: 6px;\n  background-color: transparent;\n  color: #0074b3;\n  cursor: pointer;\n  width: auto;\n  min-height: auto;\n}\n\n.reihenfolge-admin-buttons button:hover:not(:disabled) {\n  background-color: rgba(0, 116, 179, 0.15);\n}\n\n.reihenfolge-admin-buttons button:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.reihenfolge-admin-buttons button .material-symbols-outlined {\n  font-size: 1.2rem;\n}\n\n.reihenfolge-admin-buttons .reihenfolge-admin-entfernen {\n  color: var(--blutorange);\n}\n\n.reihenfolge-admin-buttons .reihenfolge-admin-entfernen:hover:not(:disabled) {\n  background-color: rgba(200, 60, 30, 0.15);\n}\n\n/* ─── Zelt hinzufügen ─── */\n\n.reihenfolge-admin-hinzufuegen {\n  display: flex;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.reihenfolge-admin-hinzufuegen input[type=\"text\"] {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.reihenfolge-admin-hinzufuegen .btn-save {\n  flex: 0 0 auto;\n  padding: 0 14px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
